import type { GenerateProps } from '@pdfme/common';

export const reportSuccessMessage = 'Report generated';

export const REPORT_REQUEST = 'REPORT_REQUEST';
export const REPORT_SUCCESS = 'REPORT_SUCCESS';
export const REPORT_FAILURE = 'REPORT_FAILURE';

export interface ReportState {
  data: any;
  loading: boolean;
  error: string | null;
}

export interface ReportParams {
  fileName: string;
  template: GenerateProps | undefined;
}

interface ReportRequestAction {
  type: typeof REPORT_REQUEST;
}

interface ReportSuccessAction {
  type: typeof REPORT_SUCCESS;
  payload: ReportParams;
}

interface ReportFailureAction {
  type: typeof REPORT_FAILURE;
  payload: string;
}

export type ReportActionTypes = ReportRequestAction | ReportSuccessAction | ReportFailureAction;
